export default {
	computed: {
		lookAheadDate() {
			const lookAhead = parseInt(this.schedulingData.lookAhead) || 2592000;
			return moment().add(lookAhead, "seconds").add(1, "day")
		},
		
		isFullCalendarView() {
			return this.brandingData.type == 'calendar-view';
		},
		
		isAutoSettings() {
			return this.schedulingData.type == "auto"
		},
		
		isManualSettings() {
			return this.schedulingData.type == "manual"
		},

		serviceSelectionScreenEnabled() {
			return this.calendarData.settings.serviceSelectionEnabled;
		},

		showingTeamAppointments() {
			return this.$store.getters.isShowingTeamAppointments;
		},

		isTeamCalendar() {
			return this.calendarData.settings.calendarType === "teams";
		},
 		
		appointmentOptions() {
			let options = this.calendarData.appointments.map((item) => {
				item['label'] = item.name ? item.name : `${item.duration} minutes appointment.`;
				return item;
			});
			
			// Adding a default "All" option to appointments, which will be selected by default if service selection is not enabled 
			// and we are not showing service from URL.
			if (this.isFullCalendarView && this.isManualSettings) {
				let optionToShowAll = {label: "All", id: -1, duration: 30}
				options.unshift(optionToShowAll)

				let urlQueryService = this.$root.getURLQueryValue("service");
				if (!this.serviceSelectionScreenEnabled && !urlQueryService) {
					this.setSelectedAppointment(optionToShowAll);
				}
			}
			return options;
		},

		slots() {
			this.calendarTimezone = this.schedulingData.timezone;
			this.currentDate = moment(this.date).tz(this.calendarTimezone, true);
			this.selectedDuration = this.duration || 30;
			
			let slots = this.getSlots();
			let isHideBusySlots = this.$store.getters["isHideBusySlots"];
			
			if (isHideBusySlots) {
				slots = slots.filter((slot) => {
					return slot.available
				})
			}
			
			return slots;
		}
	},

	methods: {
		getCalendarBg(opacityRatio) {
			var lightColor = this.$root.hexToRgbA(this.brandingData.primaryColor, 0.7*opacityRatio);
			var primaryColor = this.$root.hexToRgbA(this.brandingData.primaryColor, 1*opacityRatio);
			var gradient = "background: linear-gradient(135deg, " + lightColor + " 0%, " + primaryColor + " 50%, " + lightColor + " 100%);";
			return gradient;
		},
	
		setAppointment(appointment) {
			this.setSelectedAppointment(appointment);

			this.setIsSlotAvailable(true);
			this.setIsBookingAvailable(true);
		},
	
		getSlots() {

			var slots = [];
			const weekdayDate = this.currentDate.format("YYYY-MM-DD");

			for (let appointment of this.availabilitySlots) {

				// Getting slots only for selected appointment
				if (appointment.uuid === this.selectedAppointment.uuid) {
					const vm = this;
					// Filtering out slots for selected date
					slots = _.filter(appointment.slots, (slot) => {
						let slotDate = moment(slot.from).tz(vm.timezone).format("YYYY-MM-DD")
						return  slotDate == weekdayDate;
					})

					// We'll only get slots for selected appointment
					break;
				}
			}

			// Setting not availability text message for visitors
			if (this.isAutoSettings) {
				const weekdayName = this.currentDate.format("dddd");
				const weekdaySettings = _.find(this.schedulingData.days, {name: weekdayName});
				
				// falls in a day with no slot OR no availability and not a team calendar ? disable
				if (slots.length < 1 || (!this.isTeamCalendar && !weekdaySettings.available)) {
					this.setIsSlotAvailable(false);
					return [];
				}
			} 

			// Setting not availability text message for visitors
			if (this.isManualSettings) {
				// getting recurring availability available on selected weekday
				const weekday = parseInt(this.currentDate.format("d"));
				var weekdayAvailabilities = _.filter(this.schedulingData.recurring, (e) => e.daysOfWeek.includes(weekday));

				// falls in a day with no availability and not a team calendar ? disable		
				if (!this.isTeamCalendar && weekdayAvailabilities.length < 1) {
					this.setIsSlotAvailable(false);
					return [];
				}

				// Checking if no slot available for any appointment, disable today
				let anyAppointmentSlotAvailable = false;
				this.availabilitySlots.forEach((app) => {

					if (anyAppointmentSlotAvailable == true) {return;}

					let todaySlot = _.find(app.slots, (slot) => {
						let slotDate = moment(slot.from).format("YYYY-MM-DD")
						return slotDate == weekdayDate;
					})
					
					anyAppointmentSlotAvailable = !!todaySlot;
				})
				if (anyAppointmentSlotAvailable == false) {
					this.setIsSlotAvailable(false);
					return [];
				}

				// if no slot available for selected the appointment show no appointment error message
				if (slots.length < 1) {
					this.setIsBookingAvailable(false);
					return [];
				}
			}

			return slots;
		},
	
		getInitialFullCalendarEvents(fetchInfo, successCallback, failureCallback) {
			var allEvents = [];
			this.noEventFlag = false;

			if (this.isAutoSettings) {
				// TODO- We are not supporting the auto settings for calendar view yet
				successCallback(allEvents);
			}

			if (this.isManualSettings) {

				this.setLoadingSlotsFlag(true);

				$.ajax({
					url: `${this.$store.getters.sprintfulBaseUrl}/pages/get_availability`,
					type: "GET",
					dataType: 'json',
					data: {
						start_date: moment(fetchInfo["start"]).format("YYYY-MM-DD HH:mm:ss UTC"),
						end_date: moment(fetchInfo["end"]).endOf('day').format("YYYY-MM-DD HH:mm:ss UTC"),
						calendar_slug: this.calendarData.slug
					},
	
					xhrFields: {
						withCredentials: true
					},
	
					success: (data) => {
						if (data.success) {
							// Needs to format as reequired by FullCalendar
							allEvents = this.formatEventsForFullCalendar(data.availability_slots);

							this.setAvailabilityGeneratedAt(data.generated_at);
							this.setAvailabilitySlots(allEvents);

							if (allEvents.length === 0) { this.noEventFlag = true; }
							successCallback(allEvents);
							this.$store.commit("setLoggedInUserEmail", data.logged_in_user_email);
							this.setLoadingSlotsFlag(false);
						} else {
							this.$store.commit("setLoggedInUserEmail", data.logged_in_user_email);
							this.setActiveView('unavailable');
							successCallback(allEvents);
						}
					},
				})
			}
		},

		formatEventsForFullCalendar(events) {
			const vm = this;
			let formattedEvents = [];

			events.forEach(function(appointment, index) {
				let color = vm.defaultColors[index];

				// Only include slots for selected appointment.
				if (vm.selectedAppointment.id == -1 || appointment.uuid == vm.selectedAppointment.uuid) {
					appointment.slots.forEach((slot) => {

						if (slot.available) {
							formattedEvents.push({
								appointment_uuid: appointment.uuid,
								color: color,
								end: slot.to,
								start: slot.from,
								title: slot.title || appointment.name
							})
						}
					})
				}
			})

			return formattedEvents;
		},

		isAnySlotAvailableForTheDay(date) {
			let currDate = new Date(date);
			let slotAvailable = false;
			let appointment = this.$store.state.selectedAppointment;

			for (let app of this.availabilitySlots) {

				// Only check for selected appointment
				if (appointment && app.uuid !== appointment.uuid) {
					continue;
				}

				for (let slot of app.slots) {
					if (!slot.available) {continue;}

					let slotDate = new Date(slot.from);

					if (currDate.getFullYear() == slotDate.getFullYear() && 
						currDate.getMonth() == slotDate.getMonth() && 
						currDate.getDate() == slotDate.getDate()
						) {
						slotAvailable = true;
						break;
					}
				}

				if (slotAvailable == true) {break;}
			}

			return slotAvailable;
		}
	}
}